import { Screen } from '@vote4dance/judging-schema';
import { CompetitionId, ScreenSettings } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

export type ScreenItem = Screen;

type ScreenItemCompanion = {
    getScreenSettings(Screen: ScreenItem): ScreenSettings;
}

export const ScreenItem: ScreenItemCompanion = {
    getScreenSettings(screen: ScreenItem): ScreenSettings {
        const settings = screen.screen_settings ? JSON.parse(screen.screen_settings) : {};
        return settings;
    }
}

export function ScreenSource(event_id: CompetitionId) {
    return new StreamSource<ScreenItem[]>(`/screen/${event_id}`);
}